// extracted by mini-css-extract-plugin
export default {"dribbbleIcon":"tiWnxz"};